<!-- 标题 -->
<template>
  <div class="zlr-title"
       :class="[colorCls]">{{title}}</div>
</template>

<script>
let prefixCls = 'zlr-title'
export default {
  name: 'zlr-title',
  props: {
    title: {
      required: true
    },
    depth: {
      default: 85
    }
  },
  components: {},
  data () {
    return {
    }
  },
  computed: {
    colorCls () {
      return `${prefixCls}-${this.depth}`
    }
  },
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
.zlr-title {
  font-size: 20px;
  line-height: 30px;
}
.zlr-title-65 {
  color: rgba(0, 0, 0, 0.65);
}
.zlr-title-85 {
  color: rgba(0, 0, 0, 0.85);
}
</style>
